import {InjectionToken, Provider} from '@angular/core';
import {ActionReducerMap} from '@ngrx/store';
import {CustomFamiliesListState} from '../custom-families-state';
import {CustomFamiliesActionTypes, CustomFamiliesListActions} from '../actions/custom-families.action';

export const initialState: any[] = [];

export const initialFamilyState: any = {};

export function FamiliesReducer(
  state = initialState,
  action: CustomFamiliesListActions,
): any[] {
  switch (action.type) {
    case CustomFamiliesActionTypes.LOAD_FAMILIES_FAIL: {
      return initialState;
    }
    case CustomFamiliesActionTypes.LOAD_FAMILIES_SUCCESS: {
      return action.payload ? action.payload : initialState;
    }
  }
  return state;
}

export function getFamiliesReducers(): ActionReducerMap<CustomFamiliesListState> {
  return {
    families: FamiliesReducer
  };
}

export const reducerFamiliesToken: InjectionToken<ActionReducerMap<CustomFamiliesListState>> = new InjectionToken<ActionReducerMap<CustomFamiliesListState>>(
  'FamiliesReducers',
);

export const reducerFamiliesProvider: Provider = {
  provide: reducerFamiliesToken,
  useFactory: getFamiliesReducers,
};
